import { Component, ErrorInfo, PropsWithChildren } from 'react'
import { RawError } from '@components/shared/errors/RawError.tsx'

class ErrorBoundary extends Component<PropsWithChildren> {
  state = {
    hasError: false,
  }

  componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    this.setState({ hasError: true })

    if (process.env.NODE_ENV !== 'production') {
      console.error('ErrorBoundary caught an error:', error, errorInfo)
      console.error(error, errorInfo)
    }
  }

  render() {
    if (this.state.hasError) {
      return <RawError />
    }

    return this.props.children
  }
}

export default ErrorBoundary
